"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_slider_1 = __importDefault(require("react-slider"));
var filter_1 = __importDefault(require("lodash/filter"));
var last_1 = __importDefault(require("lodash/last"));
var NTDSizeGuideApp = /** @class */ (function (_super) {
    __extends(NTDSizeGuideApp, _super);
    function NTDSizeGuideApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentSize: _this.props.sizes[0],
        };
        _this.selectSize = function (value) {
            var eligibleSizes = (0, filter_1.default)(_this.props.sizes, function (sz) {
                return sz.startWeight <= value;
            });
            _this.setState({ currentSize: (0, last_1.default)(eligibleSizes) || _this.props.sizes[0] });
        };
        _this.getSliderValue = function (value) {
            var _a;
            var highestValue = ((_a = (0, last_1.default)(_this.props.sizes)) === null || _a === void 0 ? void 0 : _a.startWeight) || 0;
            if (value > highestValue) {
                return "".concat(highestValue, "+ lbs.");
            }
            return "".concat(value, " lbs.");
        };
        return _this;
    }
    NTDSizeGuideApp.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: 'small-padding-horizontal-10 margin-top-5' },
            React.createElement("h4", { className: 'h4 text-center' }, this.props.weightSliderTitle),
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'cell large-4 large-offset-4' },
                    React.createElement(react_slider_1.default, { className: 'ntd-rs-horizontal-slider', thumbClassName: 'ntd-rs-slider-thumbnail', trackClassName: 'ntd-rs-track', value: this.state.currentSize.startWeight || this.props.minWeight, min: this.props.minWeight, max: this.props.maxWeight, onChange: this.selectSize, ariaLabel: "Child's Weight", ariaValuetext: function (state) { return "".concat(state.valueNow, " lbs."); }, renderThumb: function (props, state) { return (React.createElement("div", __assign({}, props),
                            React.createElement("div", { className: 'ntd-rs-current-value' }, _this.getSliderValue(state.valueNow)))); } }))),
            React.createElement("div", { className: 'grid-x margin-top-24' },
                React.createElement("div", { className: 'cell large-6 large-offset-3' },
                    React.createElement("div", { className: 'grid-x text-center' }, this.props.sizes.map(function (size) {
                        return (React.createElement("div", { key: size.name, className: (0, classnames_1.default)('cell small-3', 'cell-size-value', _this.state.currentSize.name == size.name ? 'h1' : 'h3 text-bluey-purple') }, size.name));
                    })))),
            React.createElement("div", { className: 'margin-top-20 text-center' },
                "size ",
                this.state.currentSize.name,
                " contains ",
                React.createElement("span", { className: 'h4' }, this.state.currentSize.bagQty),
                " nighttime diapers.")));
    };
    return NTDSizeGuideApp;
}(React.Component));
exports.default = NTDSizeGuideApp;
